export interface IBase {
  id: number | string;
}
